
// 插件路由
const seventuan = () => import(/* webpackChunkName: "example" */ '~/addon/seventuan/pages/seventuan.vue')

const routes = [
	{ 
        path: '/seventuan', 
        component: seventuan 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/seventuan/router/index.js